import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box,
  Typography, Button, Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import {
  Close, ExpandMore, PunchClock, Inventory2, ReceiptLong, Lock, Replay,
  PriceChange, Print, MenuBook,
} from '@mui/icons-material';
import GuiaActualizarPrecios from './GuiaActualizarPrecios.jsx';

// Guía de uso en formato pregunta/respuesta (acordeón) — pensada para que
// un franquiciado o un empleado nuevo encuentre rápido la respuesta puntual
// que necesita, en vez de tener que leer un tutorial lineal de punta a
// punta. Vive en un componente propio (no adentro de Dashboard.jsx) porque
// es contenido, no lógica de pantalla.

const PREGUNTAS = [
  {
    icono: PunchClock,
    pregunta: '¿Cómo abro un turno?',
    respuesta: 'Antes de poder registrar un egreso necesitás un turno de caja abierto en tu sucursal. Se abre desde "Turnos de caja".',
  },
  {
    icono: Inventory2,
    pregunta: '¿Cómo registro un egreso de mercadería?',
    respuesta: 'Desde "Registrar Egreso": elegís los productos que salen de stock y confirmás. Esto descuenta el stock de cada '
      + 'producto — no es una venta ni un punto de venta, es un registro de salida de mercadería. Hace falta tener un turno '
      + 'abierto (ver la pregunta anterior).',
  },
  {
    icono: ReceiptLong,
    pregunta: 'Me equivoqué en un egreso de mercadería, ¿lo puedo corregir?',
    respuesta: 'Sí, podés modificarlo o anularlo desde "Registro de egresos de productos".',
  },
  {
    icono: Lock,
    pregunta: '¿Cómo cierro el turno?',
    respuesta: 'Desde "Turnos de caja", cerralo cuando termine el día (o ese turno) — se manda un resumen por mail a la sucursal.',
  },
  {
    icono: Replay,
    pregunta: 'Ya cerré el turno, ¿cómo registro otro egreso?',
    respuesta: 'Tenés que abrir un turno nuevo — se vuelve a la primera pregunta.',
  },
  {
    icono: PriceChange,
    pregunta: '¿Cómo actualizo los precios cuando Grido manda la lista nueva?',
    respuesta: 'Subí el Excel que te manda Grido (la pestaña que dice "Grido") desde "Actualizar precios": el sistema te muestra '
      + 'los cambios de precio y no aplica nada hasta que vos confirmes. Si alguna línea no se reconoce, la relacionás una sola '
      + 'vez con su producto desde "Mapeo de precios". Mirá la guía con imágenes, paso a paso:',
    guiaPrecios: true,
    soloPerfiles: [1, 2], // Actualizar precios es solo de Administrador y Franquiciado
  },
  {
    icono: Print,
    pregunta: '¿Cómo configuro la impresora de comandas en mi PC de caja?',
    respuesta: 'Instalá QZ Tray (gratis, desde qz.io) en esa PC. Pedile al administrador el archivo del certificado '
      + '(override.crt) — lo genera una sola vez desde Configuración y te lo puede mandar por mail o WhatsApp — y copialo '
      + 'en la carpeta C:\\Program Files\\QZ Tray\\ de esa PC (puede pedir permisos de administrador para guardarlo ahí). '
      + 'Reiniciá QZ Tray después de copiarlo (click derecho en su ícono de la bandeja → Exit, y volver a abrirlo). '
      + 'La primera vez que imprimís puede aparecer un cartel de QZ Tray pidiendo permiso — tocá "Allow".',
  },
];

function GuiaUso({ open, onClose }) {
  const [guiaPreciosAbierta, setGuiaPreciosAbierta] = useState(false);
  let perfil = 0;
  try { perfil = Number(JSON.parse(sessionStorage.getItem('userData') || '{}')?.perfil); } catch { perfil = 0; }
  const preguntas = PREGUNTAS.filter((p) => !p.soloPerfiles || p.soloPerfiles.includes(perfil));
  return (
    <>
    <GuiaActualizarPrecios open={guiaPreciosAbierta} onClose={() => setGuiaPreciosAbierta(false)} />
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Preguntas frecuentes
        <IconButton size="small" onClick={onClose}><Close fontSize="small" /></IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {preguntas.map(({ icono: Icono, pregunta, respuesta, guiaPrecios }, i) => (
          <Accordion key={i} defaultExpanded={i === 0} disableGutters elevation={0} square>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Icono color="primary" fontSize="small" />
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{pregunta}</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">{respuesta}</Typography>
              {guiaPrecios && (
                <Button variant="contained" size="small" startIcon={<MenuBook />} sx={{ mt: 1.5 }} onClick={() => setGuiaPreciosAbierta(true)}>
                  Ver paso a paso con imágenes
                </Button>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>Entendido</Button>
      </DialogActions>
    </Dialog>
    </>
  );
}

export default GuiaUso;
